import { isFinanceProject, isGlobalProject } from 'config';

export const getClientOtherFormSectionKeys = (): string[] => {
  if (isFinanceProject()) {
    return [
      'activity',
      'biography',
      'bankAccounts',
      'financingSources',
      'debts',
    ];
  }

  if (isGlobalProject()) {
    return [
      'activity',
      'W8BenForm',
      'businessRelationship',
      'riskProfile',
      'knowledgeAndExperience',
      'financialPosition',
    ];
  }

  return [];
};
